module.exports = __webpack_public_path__ + "img/bgImg.8d3ef0f0.png";